import React, { useState } from "react";
import _ from "lodash";
import {
  Container,
  SearchBarIcon,
  StyledCloseIcon,
} from "styles/components/SearchBar";
import TextField from "components/TextField";

const SearchBar = ({ searchById, fetchAllOrders }) => {
  const [search, setSearch] = useState(undefined);

  const onKeyDown = (e) => {
    if (e.keyCode === 13 && !!search?.trim()?.length) {
      searchById(search);
    }
  };

  return (
    <Container>
      <TextField
        fullWidth
        placeholder="Search"
        onKeyDown={onKeyDown}
        value={search || ""}
        onChange={(v) => setSearch(v)}
      />

      {!!search?.trim().length && (
        <StyledCloseIcon
          onClick={() => {
            setSearch(undefined);
            _.isFunction(fetchAllOrders) && fetchAllOrders();
          }}
        />
      )}
      <SearchBarIcon
        onClick={() => !!search?.trim()?.length && searchById(search)}
      />
    </Container>
  );
};

export default SearchBar;
